export default {
    indexInstitutionIntegrationItems:  { method: 'get',    url: 'institution_integration_items' },
    storeInstitutionIntegrationItem:   { method: 'post',   url: 'institution_integration_items' },
    updateInstitutionIntegrationItem:  { method: 'put',    url: 'institution_integration_items/{id}'},
    destroyInstitutionIntegrationItem: { method: 'delete', url: 'institution_integration_items/{id}'},
}